'use client'

export default function PrivacyPolicyPage() {
  return (
    <main style={{ padding: '0px 20px', textAlign: 'center' }}>
      <h1>Согласие на обработку персональных данных
      </h1>
      <iframe
        src="/docs/access_pd.pdf"
        width="100%"
        height="800px"
        style={{ border: 'none', marginTop: '30px' }}
        title="Согласие на обработку персональных данных"
      />
    </main>
  );
}
